var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { avoidAuthToken } from "./../../../../constants";
import optionConfigURL from "@adapters/infrastructures/urlConfig/Markets/optionsURL";
import { EOptionDrivingMarketSectionType, } from "@domains/features/Markets/Options/entites/drivingMarket";
import { OptionChainScreens, } from "@domains/features/Markets/Options/entites/iOptionChain";
import { fnoBanMapper } from "@domains/features/Markets/Common/mapper/fnoBan";
import { optionChainMapper } from "@domains/features/Markets/Options/mapper/optionChainMapper";
import { optionDrivingMarketMapper } from "@domains/features/Markets/Options/mapper/optionDrivingMarketMapper";
import { opRecommendationMapper } from "../../../../../domains/features/Markets/Options/mapper/opRecommendationMapper";
import bseNseExpiryMapper from "../../../../../domains/features/Markets/Options/mapper/bseNseExpiryMapper";
var OptionRepository = /** @class */ (function () {
    function OptionRepository(http) {
        this.http = http;
    }
    OptionRepository.prototype.getOptionChainData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, optionChain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL("".concat(optionConfigURL.optionTable, "/").concat(req.exchange, "/").concat(req.inst, "/").concat(req.symbol, "/").concat(req.expData));
                        url.searchParams.append("screen", req.screen ? req.screen : OptionChainScreens.CHAIN);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        optionChain = _a.sent();
                        return [2 /*return*/, optionChainMapper(optionChain.data, req.screen ? req.screen : OptionChainScreens.CHAIN)];
                }
            });
        });
    };
    OptionRepository.prototype.getExpiryDateData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, expiryDate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(optionConfigURL.expiryDate);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        expiryDate = _a.sent();
                        return [2 /*return*/, expiryDate];
                }
            });
        });
    };
    OptionRepository.prototype.getFnoBanData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, fnoBanData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(optionConfigURL.fnoBan);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        fnoBanData = _a.sent();
                        return [2 /*return*/, fnoBanMapper(fnoBanData === null || fnoBanData === void 0 ? void 0 : fnoBanData.data)];
                }
            });
        });
    };
    OptionRepository.prototype.getOpRecommendationsData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, opRecommendations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(optionConfigURL.recommendations);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        opRecommendations = _a.sent();
                        return [2 /*return*/, opRecommendationMapper(opRecommendations.data)];
                }
            });
        });
    };
    OptionRepository.prototype.getHighestGainerLoser = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, type, highestGainer;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(optionConfigURL.gainerLosers);
                        url.searchParams.append("type", req.type);
                        url.searchParams.append("period", req.period);
                        type = req.type === "loss"
                            ? EOptionDrivingMarketSectionType.HIGHEST_OI_LOSER
                            : EOptionDrivingMarketSectionType.HIGHEST_OI_GAINER;
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        highestGainer = _a.sent();
                        return [2 /*return*/, optionDrivingMarketMapper(highestGainer.data, type, req.viewAll)];
                }
            });
        });
    };
    OptionRepository.prototype.getHighestOIData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, highestOI;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(optionConfigURL.highestOI);
                        url.searchParams.append("period", req.period);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        highestOI = _a.sent();
                        return [2 /*return*/, optionDrivingMarketMapper(highestOI.data, EOptionDrivingMarketSectionType.HIGHEST_OI, req.viewAll)];
                }
            });
        });
    };
    OptionRepository.prototype.getHighestVolumeData = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, highestVolume;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(optionConfigURL.highestVolume);
                        url.searchParams.append("period", req.period);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: avoidAuthToken,
                            })];
                    case 1:
                        highestVolume = _a.sent();
                        return [2 /*return*/, optionDrivingMarketMapper(highestVolume.data, EOptionDrivingMarketSectionType.HIGHEST_VOLUME, req.viewAll)];
                }
            });
        });
    };
    OptionRepository.prototype.getBseNseExpiryDates = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = new URL(optionConfigURL.expiry);
                        return [4 /*yield*/, this.http.makeApiCall({
                                method: "GET",
                                url: url.toString(),
                                avoidAuthToken: true,
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, bseNseExpiryMapper(result === null || result === void 0 ? void 0 : result.data)];
                }
            });
        });
    };
    return OptionRepository;
}());
export default OptionRepository;
